(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["lp-growth-stories"] && !Shopify.designMode) return;
  try {
    
  /**
   * <lp-rail> — arrows for a CSS scroll-snap card rail.
   *
   * The rail scrolls natively, so this only adds the desktop prev/next
   * buttons and keeps their state in sync. Arrows hide when nothing
   * overflows.
   */
  if (!customElements.get('lp-rail')) {
    customElements.define(
      'lp-rail',
      class LpRail extends HTMLElement {
        connectedCallback() {
          this.viewport = this.querySelector('[data-rail-viewport]');
          this.track = this.querySelector('[data-rail-track]');
          this.prev = this.querySelector('[data-rail-prev]');
          this.next = this.querySelector('[data-rail-next]');

          if (!this.viewport || !this.track) return;

          this.sync = this.sync.bind(this);
          this.viewport.addEventListener('scroll', this.sync, {
            passive: true,
          });
          window.addEventListener('resize', this.sync, { passive: true });

          if (this.prev) {
            this.prev.addEventListener('click', () => this.scrollBy(-1));
          }

          if (this.next) {
            this.next.addEventListener('click', () => this.scrollBy(1));
          }

          this.sync();
        }

        disconnectedCallback() {
          if (this.viewport) {
            this.viewport.removeEventListener('scroll', this.sync);
          }

          window.removeEventListener('resize', this.sync);
        }

        /** One card plus the track gap, in px. */
        get step() {
          const slide = this.track.firstElementChild;

          if (!slide) return this.viewport.clientWidth;

          const gap =
            parseFloat(getComputedStyle(this.track).columnGap) || 0;

          return slide.getBoundingClientRect().width + gap;
        }

        scrollBy(direction) {
          const reduce = window.matchMedia(
            '(prefers-reduced-motion: reduce)',
          ).matches;

          this.viewport.scrollBy({
            left: this.step * direction,
            behavior: reduce ? 'auto' : 'smooth',
          });
        }

        sync() {
          // 2px of slack: sub-pixel widths never settle on an exact end.
          const max = this.viewport.scrollWidth - this.viewport.clientWidth;
          const overflows = max > 2;

          if (this.prev) {
            this.prev.disabled = this.viewport.scrollLeft <= 2;
            this.prev.hidden = !overflows;
          }

          if (this.next) {
            this.next.disabled = this.viewport.scrollLeft >= max - 2;
            this.next.hidden = !overflows;
          }
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-growth-timeline"] && !Shopify.designMode) return;
  try {
    
  /**
   * <lp-timeline> — progressive reveal for the routine timeline.
   *
   * Stages start dimmed and light up as they cross the reading line, with a
   * vertical bar tracking progress. Reduced-motion visitors get everything
   * revealed at once.
   */
  if (!customElements.get('lp-timeline')) {
    customElements.define(
      'lp-timeline',
      class LpTimeline extends HTMLElement {
        connectedCallback() {
          this.stages = Array.from(this.querySelectorAll('[data-stage]'));
          this.progress = this.querySelector('[data-progress]');

          if (!this.stages.length) return;

          this.ticking = false;
          this.onScroll = this.request.bind(this);

          window.addEventListener('scroll', this.onScroll, {
            passive: true,
          });
          window.addEventListener('resize', this.onScroll, {
            passive: true,
          });

          this.update();
        }

        disconnectedCallback() {
          window.removeEventListener('scroll', this.onScroll);
          window.removeEventListener('resize', this.onScroll);
        }

        request() {
          if (this.ticking) return;

          this.ticking = true;
          requestAnimationFrame(() => {
            this.update();
            this.ticking = false;
          });
        }

        update() {
          const reduce = window.matchMedia(
            '(prefers-reduced-motion: reduce)',
          ).matches;
          // 62% down the viewport reads as "the line being read now".
          const line = window.innerHeight * 0.62;
          // 2px of slack: fractional page heights never hit an exact end.
          const atEnd =
            window.innerHeight + window.scrollY >=
            document.documentElement.scrollHeight - 2;
          let revealed = 0;

          this.stages.forEach((stage, index) => {
            const visible =
              reduce ||
              atEnd ||
              index === 0 ||
              stage.getBoundingClientRect().top <= line;

            stage.classList.toggle('is-revealed', visible);
            stage.classList.toggle('is-dimmed', !visible);

            if (visible) revealed = index + 1;
          });

          if (!this.progress) return;

          // The bar spans dot to dot, so n stages means n-1 gaps to fill.
          const gaps = this.stages.length - 1;
          const ratio = gaps > 0 ? Math.max(0, (revealed - 1) / gaps) : 1;

          this.progress.style.height = `${ratio * 100}%`;
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lp-routine-part"] && !Shopify.designMode) return;
  try {
    
  /**
   * <lp-tabs> — tabbed panels plus the point drawers.
   *
   * Progressive enhancement: the markup ships every panel visible, so with
   * no JavaScript a visitor still gets all the content, just stacked. On
   * connect this collapses to the tab marked selected (or the first) and
   * handles clicks and left/right arrow keys per the ARIA tabs pattern.
   */
  if (!customElements.get('lp-tabs')) {
    customElements.define(
      'lp-tabs',
      class LpTabs extends HTMLElement {
        connectedCallback() {
          this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
          this.panels = Array.from(
            this.querySelectorAll('[role="tabpanel"]'),
          );

          this.bindDrawers();

          if (this.tabs.length < 2 || !this.panels.length) return;

          this.tabs.forEach((tab) => {
            tab.addEventListener('click', () => this.select(tab));
          });

          const list = this.querySelector('[role="tablist"]');

          if (list) {
            list.addEventListener('keydown', this.onKeydown.bind(this));
          }

          const initial =
            this.tabs.find(
              (t) => t.getAttribute('aria-selected') === 'true',
            ) || this.tabs[0];

          this.select(initial);
        }

        bindDrawers() {
          this.querySelectorAll('[data-drawer-open]').forEach((button) => {
            const drawer = this.querySelector(
              `#${button.getAttribute('data-drawer-open')}`,
            );

            if (!drawer) return;

            button.addEventListener('click', () => drawer.showModal());
            drawer
              .querySelector('[data-drawer-close]')
              ?.addEventListener('click', () => drawer.close());
          });
        }

        onKeydown(event) {
          if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') {
            return;
          }

          event.preventDefault();

          const current = this.tabs.findIndex(
            (t) => t.getAttribute('aria-selected') === 'true',
          );
          const step = event.key === 'ArrowRight' ? 1 : -1;
          const next = (current + step + this.tabs.length) %
            this.tabs.length;

          this.select(this.tabs[next]);
          this.tabs[next].focus();
        }

        select(tab) {
          const target = tab.getAttribute('aria-controls');

          this.tabs.forEach((t) => {
            const isCurrent = t === tab;

            t.setAttribute('aria-selected', String(isCurrent));
            t.setAttribute('tabindex', isCurrent ? '0' : '-1');
          });

          this.panels.forEach((panel) => {
            panel.hidden = panel.id !== target;
          });
        }
      },
    );
  }

  } catch(e) { console.error(e); }
})();
})();
